<script setup>
import { tv } from 'tailwind-variants';

/**
 * @typedef {object} DividerProps
 * @property {('primary'|'secondary')} [variant='primary'] - Style variant of the divider
 */

/**
 * @type {DividerProps}
 */
const props = defineProps({
  variant: {
    type: String,
    default: 'primary',
  },
});

const dividerRecipe = tv({
  base: 'w-full border-t',
  variants: {
    variant: {
      primary: 'border-brand-border',
      secondary: 'border-brand-border-secondary',
    },
    // NOTE: Special case. We need to reset the margin cause by chatwoot global styles.
    reset: {
      true: 'm-0',
    },
  },
  defaultVariants: {
    reset: true,
  },
});
</script>

<template>
  <hr
    data-component="CsDivider"
    :class="dividerRecipe({ variant: props.variant })"
  />
</template>
